import { useEffect, useState } from "react";
import { api } from "../../config/api";

// Notification totals come from the API, independently of order messages and popups.
export default function useCourseUnreadCount(enabled, pathname) {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!enabled) { setCount(0); return; }
    let disposed = false;
    let sequence = 0;
    let timer;
    const token = localStorage.getItem("token");
    const refresh = async () => {
      const current = ++sequence;
      try {
        const response = await api.get("/courses/notifications?limit=1");
        const total = response.data?.data?.unreadMessages;
        if (!disposed && current === sequence && localStorage.getItem("token") === token && Number.isSafeInteger(total) && total >= 0) setCount(total);
      } catch (_) {
        // A temporary failure must not clear a known unread count.
      }
    };
    const schedule = () => {
      if (document.visibilityState === "hidden") return;
      clearTimeout(timer);
      timer = setTimeout(refresh, 100);
    };
    refresh();
    window.addEventListener("course-unread-changed", schedule);
    window.addEventListener("focus", schedule);
    document.addEventListener("visibilitychange", schedule);
    const interval = setInterval(schedule, 60000);
    return () => {
      disposed = true;
      clearTimeout(timer);
      clearInterval(interval);
      window.removeEventListener("course-unread-changed", schedule);
      window.removeEventListener("focus", schedule);
      document.removeEventListener("visibilitychange", schedule);
    };
  }, [enabled, pathname]);
  return enabled ? count : 0;
}
